export default {
  common: {
    confirm: '确定',
    cancel: '取消',
    add: '新增',
    edit: '编辑',
    delete: '删除',
    search: '搜索',
    reset: '重置',
    save: '保存',
    logout: '退出登录',
    success: '操作成功',
    error: '操作失败',
    noData: '暂无数据',
    confirmDelete: '确定删除该记录？',
    pleaseInput: '请输入',
    pleaseSelect: '请选择',
    all: '全部',
    detail: '详情',
    operation: '操作',
    id: 'ID',
    changePassword: '修改密码',
    back: '返回'
  },
  menu: {
    area: '区域管理',
    user: '用户管理',
    device: '设备管理',
    version: '版本管理',
    versionFirmware: '固件管理',
    versionApp: 'App版本管理'
  },
  login: {
    title: '登录',
    loginName: '登录名',
    password: '密码',
    loginBtn: '登录',
    loginNamePlaceholder: '请输入登录名',
    passwordPlaceholder: '请输入密码',
    loginSuccess: '登录成功',
    loginFail: '登录失败',
    pleaseInputLoginName: '请输入登录名',
    pleaseInputPassword: '请输入密码'
  },
  area: {
    title: '区域管理',
    addArea: '新增区域',
    editArea: '编辑区域',
    areaName: '区域名称',
    areaDetail: '区域描述',
    parentArea: '父级区域',
    level: '层级',
    createTime: '创建时间',
    areaNamePlaceholder: '请输入区域名称',
    areaDetailPlaceholder: '请输入区域描述',
    topArea: '顶级区域',
    operation: '操作',
    pleaseInputAreaName: '请输入区域名称',
    deleteAreaConfirm: '确定删除该区域？',
    deleteSuccess: '删除成功',
    deleteFail: '删除失败',
    updateSuccess: '更新成功',
    updateFail: '更新失败',
    addSuccess: '添加成功',
    addFail: '添加失败',
    submitFail: '提交失败',
    getAreaListFail: '获取区域列表失败'
  },
  user: {
    title: '用户管理',
    addUser: '新增用户',
    editUser: '编辑用户',
    userName: '用户姓名',
    loginName: '登录名',
    phone: '手机号',
    role: '角色',
    area: '所属区域',
    status: '状态',
    createTime: '创建时间',
    userNamePlaceholder: '请输入用户姓名',
    loginNamePlaceholder: '请输入登录名',
    phonePlaceholder: '请输入手机号',
    valid: '有效',
    invalid: '无效',
    allStatus: '全部状态',
    allRoles: '全部角色',
    keyword: '关键词',
    areaName: '区域',
    pleaseInputUserName: '请输入用户姓名',
    pleaseInputLoginName: '请输入登录名',
    pleaseInputPhone: '请输入手机号',
    pleaseSelectRole: '请选择角色',
    pleaseSelectArea: '请选择区域',
    deleteUserConfirm: '确定删除该用户？',
    deleteSuccess: '删除成功',
    deleteFail: '删除失败',
    updateSuccess: '更新成功',
    updateFail: '更新失败',
    addSuccess: '添加成功',
    addFail: '添加失败',
    submitFail: '提交失败',
    getUserListFail: '获取用户列表失败',
    getRoleListFail: '获取角色列表失败',
    getAreaListFail: '获取区域列表失败'
  },
  device: {
    title: '设备管理',
    addDevice: '新增设备',
    editDevice: '编辑设备',
    deviceDetail: '设备详情',
    deviceId: '设备ID',
    deviceName: '设备名称',
    deviceType: '设备类型',
    batchId: '批次号',
    deviceNumber: '控制器编号',
    area: '所属区域',
    status: '状态',
    createTime: '创建时间',
    deviceNamePlaceholder: '请输入设备名称',
    keywordPlaceholder: '请输入关键词搜索',
    normal: '正常',
    warning: '警告',
    offline: '离线',
    keyword: '关键词',
    warnStatus: '警告状态',
    more: '更多',
    statusDetail: '设备状态详情',
    runStatus: '运行状态',
    cmdList: '命令列表',
    settingList: '设置记录'
  },
  passwordReset: {
    title: '修改初始密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    oldPasswordPlaceholder: '请输入旧密码',
    newPasswordPlaceholder: '请输入新密码',
    confirmPasswordPlaceholder: '请确认新密码',
    submitBtn: '确认修改',
    passwordMismatch: '两次输入的密码不一致',
    passwordTooShort: '密码长度不能少于6位',
    passwordSuccess: '密码修改成功',
    passwordFail: '密码修改失败',
    pleaseInputOld: '请输入旧密码',
    pleaseInputNew: '请输入新密码',
    pleaseConfirm: '请确认新密码'
  },
  deviceDetail: {
    title: '设备详情',
    deviceVersion: '设备版本号',
    deviceModel: '控制器型号',
    warnStatus: '警告状态',
    statusDetailTitle: '设备状态详情',
    controllerVoltage: '控制器电压(V)',
    controllerCurrent: '控制器电流(A)',
    controllerTemp: '控制器温度(℃)',
    motorTemp: '电机温度(℃)',
    workStatus: '工作状态',
    softOverCurrent: '软件过流值(A)',
    softOverCurrentDuration: '软件过流持续时间(秒)',
    motorOverTemp: '电机温度过保护值(℃)',
    motorControlOverTemp: '驱动器过温保护值(℃)',
    updateTime: '更新时间',
    runStatusTitle: '设备运行状态',
    timeRange: '时间范围',
    startTime: '开始时间',
    endTime: '结束时间',
    dataList: '数据列表',
    trendChart: '趋势图表',
    time: '时间',
    cmdListTitle: '设备命令列表',
    softOverCurrentRestoreTime: '过流恢复时间(秒)',
    motorOverTempProtect: '电机过温保护(℃)',
    motorOverTempRestoreTime: '电机过温恢复(秒)',
    motorControlOverTempProtect: '驱动器过温保护(℃)',
    motorControlOverTempRestoreTime: '驱动器过温恢复(秒)',
    currentMaxProtect: '最大电流保护(A)',
    softBootInitDutyCycle: '软启动初始占空比(%)',
    softBootTime: '软启动时间(毫秒)',
    motorControlTempFixedValue: '控制器固定温度(℃)',
    motorTempFixedValue: '电机固定温度(℃)',
    tempSensorType: '温度传感器类型',
    remoteControlPairingMode: '遥控配对模式',
    settingListTitle: '获取设置记录'
  },
  layout: {
    switchToDark: '切换到暗色模式',
    switchToLight: '切换到亮色模式',
    theme: '主题',
    themeSystem: '跟随系统',
    themeDark: '深色模式',
    themeLight: '浅色模式'
  },
  statusText: {
    stopped: '停止',
    forward: '正转',
    reverse: '反转',
    unknown: '未知',
    normal: '正常',
    softOverCurrent: '软件过流',
    hardOverCurrent: '硬件过流',
    motorOverTemp: '电机过温',
    motorControlOverTemp: '驱动器过温',
    locked: '堵转'
  },
  version: {
    type: '类型',
    versionCode: '版本号',
    versionCodePlaceholder: '请输入版本号',
    versionCodeRequired: '请输入版本号',
    content: '更新内容',
    contentPlaceholder: '请输入版本更新内容',
    fileUrl: '文件地址',
    fileUpload: '文件上传',
    uploadByFile: '本地上传',
    uploadByUrl: 'URL上传',
    urlPlaceholder: '输入URL，点击上传可转存为新URL（可选）',
    urlRequired: '请输入文件URL',
    selectFile: '选择文件',
    upload: '上传',
    uploadSuccess: '文件上传成功',
    uploadFailed: '文件上传失败',
    fileUploaded: '文件已上传',
    status: '状态',
    valid: '有效',
    invalid: '无效',
    createTime: '创建时间',
    updateTime: '更新时间',
    firmware: {
      title: '固件管理',
      add: '新增固件版本',
      edit: '编辑固件版本',
      deviceModel: '设备型号',
      deviceModelPlaceholder: '请输入设备型号',
      deviceModelRequired: '请输入设备型号'
    },
    app: {
      title: 'App版本管理',
      add: '新增App版本',
      edit: '编辑App版本'
    }
  }
}
